const T = 1901, o = 40;
export {
  o as MONTH_ITEM_HEIGHT,
  T as START_YEAR
};
